import { collectionRoute } from './collection-page'
import { collectionMobileRoute } from './collection-page-mobile'
import { collectionsRoute } from './collections-page'
import { collectionsMobileRoute } from './collections-page-mobile'
import { confidentialityRoute } from './confidentiality-page'
import { desktopOnlyLayout } from './desktop-only-layout'
import { distributionAddRoute } from './distribution-add-page'
import { distributionListRoute } from './distribution-list-page'
import { distributionRoute } from './distribution-page'
import { educationRoute } from './education-page'
import { educationMobileRoute } from './education-page-mobile'
import { forbiddenRoute } from './forbidden-page'
import { baseRoute } from './layout-page'
import { mainRoute } from './main-page'
import { mainLayout } from './main-page-layout'
import { menuRoute } from './menu-wrapper-page-mobile'
import { mobileOnlyLayout } from './mobile-only-layout'
import { paymentFailedRoute } from './payment-failed-page'
import { paymentSuccessRoute } from './payment-success-page'
import { planRoute } from './plan-page'
import { planRouteMobile } from './plan-page-mobile'
import { profileInfoRoute } from './profile-info-page'
import { profileRoute } from './profile-page'
import { profileMobileRoute } from './profile-page-mobile'
import { settingsMobileRoute } from './settings-page-mobile'
import { signinRoute } from './signin-page'
import { supportRoute } from './support-page'

export const routeTree = baseRoute.addChildren([
  signinRoute,
  mainLayout.addChildren([
    mainRoute.addChildren([
      planRoute,
      paymentSuccessRoute,
      paymentFailedRoute,
      forbiddenRoute,
      confidentialityRoute, // ! This doesnt active
      supportRoute, // ! This doesnt active
      desktopOnlyLayout.addChildren([
        profileRoute.addChildren([profileInfoRoute]), // ! This doesnt active
        collectionsRoute.addChildren([collectionRoute]), // ! This doesnt active
        educationRoute,
        distributionListRoute.addChildren([
          // ! This doesnt active
          distributionRoute,
          distributionAddRoute
        ])
      ]),
      mobileOnlyLayout.addChildren([
        menuRoute.addChildren([
          settingsMobileRoute,
          planRouteMobile,
          educationMobileRoute,
          collectionsMobileRoute.addChildren([collectionMobileRoute]), // ! This doesnt active
          profileMobileRoute // ! This doesnt active
        ])
      ])
    ])
  ])
])
